import {
  EntrancePlantDetailDTO,
  PlantSyncStatusDTO,
} from 'client-generator/generated-clients/plants';
import { Options, Vue } from 'vue-class-component';
import plantsClient from '@/core/services/plants';
import { SET_APP_LOADING } from '@/core/store/action-types';
import { capitalize } from 'vue';

@Options({
  name: 'EntrancePlantStatusBanner',
  components: {},
  props: {
    plant: {
      required: true,
      type: Object as () => EntrancePlantDetailDTO,
    },
  },
  computed: {},
  emits: ['update-list'],
  watch: {},
})
export default class EntrancePlantStatusBanner extends Vue {
  isBlueBanner: boolean = false;
  isGrayBanner: boolean = false;
  isOrangeBanner: boolean = false;
  enableSyncButton: boolean = false;
  isVisibleSyncButton: boolean = false;
  showLastSyncData: boolean = false;
  bannerDetails: string = '';

  title: string = '';
  subtitle: string = '';

  plant!: EntrancePlantDetailDTO;
  lastSyncDate: string = '';
  lastSyncTime: string = '';
  config = this.plant.syncStatus as PlantSyncStatusDTO;

  async mounted(): Promise<void> {
    if (this.config.lastSyncDateTime) {
      this.lastSyncDate = this.config.lastSyncDateTime.toLocaleDateString();
      this.lastSyncTime = this.config.lastSyncDateTime!.toLocaleTimeString(navigator.language, { hour: '2-digit', minute: '2-digit' });
    }

    if (this.config.isPlantActive) {
      if (this.config.connected) {
        if (this.config.synchronized) {
          this.isBlueBanner = true;
          this.isGrayBanner = false;
          this.isVisibleSyncButton = true;
          this.enableSyncButton = false;
          this.showLastSyncData = true;
          this.title = this.$t('general.synced');
          this.subtitle = this.$t('AppResourceEP.NoChangesToSync');
          this.bannerDetails =
            this.$t('AppResourceEP.LastSync') +
            ' ' +
            capitalize(this.$t('AppResource.Now'));
        } else if (
          this.config.changesToSyncCount &&
          this.config.changesToSyncCount > 0
        ) {
          if (this.plant.gates?.some(g => g.devices?.some(d => d.needsToSyncManually))) {
            this.isOrangeBanner = true;
            this.isVisibleSyncButton = false;
            this.title = this.$t('PlantBannerChangeNoSync');
            this.subtitle = this.$t('PlantBannerNeedBTConnection');
          } else {
            this.isBlueBanner = true;
            this.isGrayBanner = false;
            this.isVisibleSyncButton = true;
            this.enableSyncButton = true;
            this.showLastSyncData = true;
            this.title = this.$t('AppResourceEP.NewChangesToSync');
            this.subtitle = this.$t('AppResourceEP.ChangesToSync');
            this.bannerDetails = this.$t('AppResourceEP.LastSync') + ' ' + this.lastSyncDate + ' ' + this.lastSyncTime;
          }
        }
      } else {
        if (this.config.synchronized) {
          this.isGrayBanner = true;
          this.isBlueBanner = false;
          this.isVisibleSyncButton = false;
          this.title = this.$t('PlantActiveNoConnectedTitle');
          this.subtitle = this.$t('PlantActiveNoConnectedSubtitle');
        } else {
          this.isBlueBanner = true;
          this.isGrayBanner = false;
          this.isOrangeBanner = false;
          this.showLastSyncData = true;
          this.title = this.$t('AppResourceEP.NewChangesToSync');
          this.subtitle = this.$t('PlantBannerNeedBTConnection');

          this.bannerDetails =
            this.$t('AppResourceEP.LastSync') +
            ' ' +
            this.lastSyncDate +
            ' ' +
            this.lastSyncTime;
        }
      }
    }
  }

  async onClickSyncNow() {
    try {
      this.$store.dispatch(SET_APP_LOADING, true);
      await plantsClient.syncwitheliot(this.plant.desktopId as number);
    } catch (error) {
      alert('Error syncing with Eliot');
    } finally {
      this.$emit('update-list')
      this.$store.dispatch(SET_APP_LOADING, false);
    }
  }
}
